import React from 'react';
import Header from '../components/Header';
import Manufacturing from '../components/Manufacturing';
import Footer from '../components/Footer';

const ManufacturingPage = () => {
  return (
    <div className="App">
      <Header />
      <Manufacturing />
      <Footer />
    </div>
  );
};

export default ManufacturingPage;

